
import AdproductsConstants from 'app/shared/constants/AdproductsConstants';

const { ProductTypes } = AdproductsConstants;

const parseProductTypes = (productTypes) => {
    const set = new Set(productTypes.map(productType => ProductTypes[productType]));
    return [...set];
};

const Listing = ({
    active = false,
    address = '',
    bedsSummary = '',
    city = '',
    dateActivated = '',
    dateCreated = '',
    dateExpiration = '',
    dateUpdated = '',
    feedId = '',
    feedName = '',
    feedListingId = '',
    isCommunity = false,
    isAddressEditable = true,
    isEditable = false,
    isMultifamily = false,
    isPaidProperty = '',
    isWaitlisted = false,
    listingAlias = '',
    listingDetails = {},
    floorPlanDetails = {},
    listingId = '',
    listingTypeCode = '',
    name = '',
    permanent = false,
    pricingSummary = '',
    primaryPhotoUrl = '',
    propertyTypeCode = '',
    rentZestimate = '',
    restrictions = {
        isPaymentsRestricted: true,
        isLeasesRestricted: true,
        applications: {
            isAccessRestricted: false,
            isUpdateRestricted: false,
        },
    },
    schedule = '',
    state = '',
    street = '',
    typeKeyphrase = '',
    unit = '',
    zip = '',
    stats = {
        numInquiries: 0,
        numViews: 0,
        numFavorites: 0,
        displayedDateSince: '',
    },
    syndication = {
        zillow: {
            status: '',
            displayStatus: '',
        },
        trulia: {
            status: '',
            displayStatus: '',
        },
        hotpads: {
            status: '',
            displayStatus: '',
        },
    },
    hasAccess = false, // Returned by analytics endpoints only
    hasVrModels = false,
    productTypes = [],
    hasBoost = false,
} = {}) => ({
    active: Boolean(active),
    address: String(address),
    bedsSummary: String(bedsSummary),
    city: String(city),
    dateActivated: String(dateActivated),
    dateCreated: String(dateCreated),
    dateExpiration: String(dateExpiration),
    dateUpdated: String(dateUpdated),
    feedId: String(feedId),
    feedName: String(feedName),
    feedListingId: String(feedListingId),
    isCommunity: Boolean(isCommunity),
    isAddressEditable: Boolean(isAddressEditable),
    isEditable: Boolean(isEditable),
    isMultifamily: Boolean(isMultifamily),
    isPaidProperty: String(isPaidProperty),
    isWaitlisted: Boolean(isWaitlisted),
    listingAlias: String(listingAlias),
    floorPlanDetails: Object(floorPlanDetails),
    listingDetails: Object(listingDetails),
    listingId: String(listingId),
    listingTypeCode: Number(listingTypeCode),
    name: String(name),
    permanent: Boolean(permanent),
    pricingSummary: String(pricingSummary),
    primaryPhotoUrl: String(primaryPhotoUrl),
    propertyTypeCode: Number(propertyTypeCode),
    rentZestimate: Number(rentZestimate),
    restrictions: Object(restrictions),
    schedule: String(schedule),
    state: String(state),
    street: String(street),
    typeKeyphrase: String(typeKeyphrase),
    unit: String(unit),
    zip: String(zip),
    stats: Object(stats),
    syndication: Object(syndication),
    hasAccess: Boolean(hasAccess),
    hasVrModels: Boolean(hasVrModels),
    productTypes: parseProductTypes(productTypes),
    hasBoost: Boolean(hasBoost),
});

export default Listing;
